<button
  [class]="hostClasses()"
  [disabled]="isLocked()"
  [attr.aria-disabled]="isLocked()"
  [pTooltip]="isLocked() ? (tooltipText() | translate) : null"
  tooltipPosition="top"
  (click)="onClick()"
  type="button"
>
  @if (isLocked()) {
    <i class="fa-solid fa-lock ai-btn__icon" aria-hidden="true"></i>
  } @else {
    <i class="fa-solid fa-bolt ai-btn__icon" aria-hidden="true"></i>
  }
  <span class="ai-btn__label">
    {{ actionText() }}&nbsp;<span class="ai-btn__suffix">{{ 'ai.with-cosmos-ai' | translate }}</span>
  </span>
</button>
